import { Button, Card, Grid, IconButton, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If, Else } from "lib/@components/switch"
import { useState } from "react"
import { Classification } from "routes/schedule/tasks/classification"
import { MoveTaskDialog } from "./move-task-dialog"
import { DraftChip } from "./draft-chip"

const gridProps = { xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }

export function TaskItem({ item }) {
    const { readOnly, category, setSelectedTaskId, refresh } = useBoundContext()
    const [moveOpen, setMoveOpen] = useState(false)

    return (
        <Grid item {...gridProps}>
            <Card
                data-cy={`task-item: ${item.heading}`}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                <Button
                    data-cy={`task-item-navigate: ${item.heading}`}
                    onClick={handleClick}
                    variant="text"
                    color="inherit"
                    sx={{
                        flexGrow: 1,
                        justifyContent: "flex-start",
                        textTransform: "none",
                        px: 2,
                        py: 1,
                        minWidth: 0,
                        textAlign: "left",
                        "&:hover": { bgcolor: "action.hover", color: "primary.main" },
                    }}
                >
                    <If truthy={item.classification !== "NotSpecified"}>
                        <Classification classification={item.classification} boxSx={{ mr: 1, flexShrink: 0 }} />
                        <Else>
                            <Iconify
                                icon="material-symbols:task-outline"
                                sx={{
                                    mr: 1,
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    flexShrink: 0,
                                }}
                            />
                        </Else>
                    </If>
                    <Typography variant="subtitle2" noWrap title={item.heading} sx={{ flexGrow: 1 }}>
                        {item.heading}
                    </Typography>
                </Button>

                <DraftChip item={item} />

                <If truthy={!readOnly}>
                    <IconButton
                        aria-label="Move task"
                        data-cy="task-item-move"
                        size="small"
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation()
                            setMoveOpen(true)
                        }}
                        sx={{ mr: 1, ml: 0.5 }}
                    >
                        <Iconify icon="eva:move-outline" width={16} height={16} />
                    </IconButton>
                </If>
            </Card>

            <If truthy={!readOnly}>
                <MoveTaskDialog
                    open={moveOpen}
                    onClose={() => setMoveOpen(false)}
                    task={item}
                    categoryId={category?.id}
                    onMoved={() => {
                        setMoveOpen(false)
                        refresh()
                    }}
                />
            </If>
        </Grid>
    )

    function handleClick() {
        setSelectedTaskId(item.id)
    }
}
